import Shared from './AppScript.js';


export default {
  ...Shared,

  methods: {
    ...Shared.methods,

    getEndpoint(selectedSize, selectedIndex) {
      return `solution/${selectedSize}/${selectedIndex}`
    },
  }
};
